import React from "react";
import "./AssetByPolygon.css";
import {Col, Row} from 'react-bootstrap';
import {InputWithLabel} from "../../component/Form/InputWithLabel";
import EPCLink from "../../component/Asset/EPCLink";
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../component/Page/Page";
import MapSelector from "../../map/MapSelector";
import HttpRequest from "../../services/HttpRequest";
import Notify from "../../services/Notify";

class AssetByPolygon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      polygons: [],
      assetByPolygon: [],
      map: null,
      epcFilter: "",
      vagaFilter: ""
    };
  }

  async componentDidMount() {
    const {map} = this.state;
    if (map) {
      await this.fetchData(map.id);
    }
  }

  fetchData = async (mapId) => {
    const http = new HttpRequest();

    try {
      const responsePolygons = await http.get(`polygon/v1/maps/${mapId}/polygons?size=50000`);
      this.setState({polygons: responsePolygons.content});

      const responseAssetByPolygon = await http.get(`/ton/v1/assets/maps/${mapId}/group-polygons`);
      this.setState({assetByPolygon: responseAssetByPolygon});
    } catch (error) {
      Notify.error('Falha ao buscarrr dados', error);
    }
  };

  getVagaStatusColor(status) {
    const statusColors = {
      'Disponível': "#c5eec9",
      'Ocupado': "#f8c2c2",
      'Parcialmente': "#f1e7cb"
    };

    return statusColors[status] || "#ffffff";
  }

  getVagaStatus(quantidadeProdutos) {
    if (quantidadeProdutos === 0) {
      return {
        status: "Disponível",
        color: this.getVagaStatusColor("Disponível")
      };
    }

    if (quantidadeProdutos < 3) {
      return {
        status: "Parcialmente",
        color: this.getVagaStatusColor("Parcialmente")
      };
    }

    return {
      status: "Ocupado",
      color: this.getVagaStatusColor("Ocupado")
    };
  }

  onChangeMap = async (map) => {
    if (!map) {
      return;
    }

    this.setState({map});

    await this.fetchData(map.id);
  };

  filterPolygonsByVaga(polygons, vagaFilter) {
    if (!vagaFilter || vagaFilter.length === 0) {
      return polygons;
    }

    const filter = vagaFilter.toLowerCase();
    return polygons.filter((polygon) => polygon.friendlyName.toLowerCase().includes(filter));
  }

  filterAssetsByEpc(assets, epcFilter) {
    if (!epcFilter || epcFilter.length === 0) {
      return assets;
    }

    const filter = epcFilter.toLowerCase();
    return assets.filter((asset) => asset.epc.value.toLowerCase().includes(filter));
  }

  getVagaByEpc(assets, polygons) {
    for (const polygon of polygons) {
      const polygonAsset = assets.find((asset) => asset.polygonId === polygon.id);
      if (polygonAsset) {
        return polygon;
      }
    }
    return null;
  }

  filterAsset(asset) {
    const {epcFilter} = this.state;

    if (!epcFilter) {
      return asset;
    }

    const filter = epcFilter.toLowerCase();
    return asset.epc.value.toLowerCase().includes(filter) ? asset : null;
  }

  printPolygon(assets) {

    const assetOldest = assets.length >= 1 ? this.filterAsset(assets[0]) : null;
    const assetMid = assets.length >= 2 ? this.filterAsset(assets[1]) : null;
    const assetTop = assets.length >= 3 ? this.filterAsset(assets[2]) : null;

    return <div className="produto">


      <span title={assetTop ? new Date(assetTop.currentState.stateDate) : null}>↑ - </span>
      {assetTop ? <EPCLink epc={assetTop.epc}/> : <p></p>}

      <span className="epc" style={{fontSize: 10}}>
                {assetTop && (assetTop.productType.reference + ' - ' + assetTop.productType.friendlyName)}
            </span>


      <span title={assetMid ? new Date(assetMid.currentState.stateDate) : null}>→ - </span>
      {assetMid ? <EPCLink epc={assetMid.epc}/> : <p></p>}

      <span className="epc" style={{fontSize: 10}}>
                {assetMid && (assetMid.productType.reference + ' - ' + assetMid.productType.friendlyName)}
            </span>


      <span title={assetOldest ? new Date(assetOldest.currentState.stateDate) : null}>↓ - </span>
      {assetOldest ? <EPCLink epc={assetOldest.epc}/> : <p></p>}

      <span className="epc" style={{fontSize: 10}}>
                {assetOldest && (assetOldest.productType.reference + ' - ' + assetOldest.productType.friendlyName)}
            </span>

    </div>

  }

  printVagas(polygons, assetByPolygon) {
    const {vagaFilter} = this.state;

    const filteredPolygons = this.filterPolygonsByVaga(polygons, vagaFilter);

    const vaga = this.getVagaByEpc(assetByPolygon, filteredPolygons);

    return (
        <div className="controle-vagas-container">
          <div className="vagas-container">
            {filteredPolygons.map((polygon, index) => {
              const polygonAsset = assetByPolygon.find(
                  (x) => x.polygonPosition.polygonId === polygon.id
              );
              let assets = polygonAsset ? polygonAsset.assets : [];

              const assetsSorted = assets.sort(
                  (a, b) => a.currentState.stateDate - b.currentState.stateDate
              );
              const {status, color} = this.getVagaStatus(assetsSorted.length);
              const assetsResult = [...assetsSorted];

              return (
                  <div key={index} className={`vaga ${vaga && vaga.id === polygon.id ? 'selected' : ''}`}>
                    <div className={`vaga-status ${status.toLowerCase()}`} style={{backgroundColor: color}}>
                      {status}
                    </div>
                    <div className="produto-container">
                      {this.printPolygon(assetsResult)}
                    </div>
                    <div className="vaga-label">{polygon.friendlyName}</div>
                  </div>
              );
            })}
          </div>
        </div>
    );
  }

  filterByEpc = (epc) => {
    this.setState({epcFilter: epc});
  };

  filterByVaga = (vaga) => {
    this.setState({vagaFilter: vaga});
  };

  render() {
    const {polygons, assetByPolygon, map} = this.state;
    return (
        <Page
            breadcrumbs={[<BreadcrumbItem key={1} title="Vagas"/>]}
            title="Controle de Vagas"
        >
          <Row>
            <Col sm={4}>
              <MapSelector onChange={this.onChangeMap}/>
            </Col>
            <Col sm={4}>
              <InputWithLabel
                  label="Vaga"
                  className="friendlyName"
                  placeholder="Vaga"
                  onChangeText={this.filterByVaga}
              />
            </Col>
            <Col sm={4}>
              <InputWithLabel
                  label="EPC"
                  className="epc"
                  placeholder="EPC"
                  onChangeText={this.filterByEpc}
              />
            </Col>
          </Row>

          {!map && <h2>Selecione um Mapa</h2>}

          {polygons && assetByPolygon && this.printVagas(polygons, assetByPolygon)}
        </Page>
    );
  }
}

export default AssetByPolygon;



// WEBPACK FOOTER //
// ./src/pages/AssetByPolygon/AssetByPolygon.js